
const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">
          <p className="text-gray-400">
            2022 - 2025 Xcelerate International. ShopXcelerate.com. All rights reserved. No affiliation with the brands mentioned on this page.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
